import { render } from "./ModalChangePassword.vue?vue&type=template&id=4a3db6b2"
import script from "./ModalChangePassword.vue?vue&type=script&lang=js"
export * from "./ModalChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__